import { Fragment } from "react";
import { Divider } from "primereact/divider";
import SignatureBox from "../../../../components/signature-box/SignatureBox";
import useIsMobile from "../../../../hooks/useIsMobile";

/**
 * The signatures of one section.
 * signers: [{ name, label, title }], name = the part after "permintaan_minyak:" of the verif label.
 * canSign: the section is the active one (the section is saved before it is signed).
 * On a phone the signatures stay in one row, in equal halves with the divider in the middle.
 */
const SignatureRow = (props) => {
  const { signers, data, verifSetting, canSign, onValidateSign, onSign } =
    props;

  const isMobile = useIsMobile();

  const renderBox = (signer) => (
    <SignatureBox
      disabled={!canSign}
      label={signer.label}
      title={signer.title}
      fieldId={`verif_${signer.name}_id`}
      fieldData={`data_verif_${signer.name}`}
      fieldDatetime={`verif_${signer.name}_datetime`}
      verifField={`permintaan_minyak:${signer.name}`}
      jabatanId={verifSetting.jabatan_id}
      jabatanIdRequirement={verifSetting[signer.name] ?? []}
      data={data}
      onValidate={() => onValidateSign(signer.name)}
      onConfirm={(confirmProps) => onSign(signer.name, confirmProps)}
    />
  );

  if (isMobile) {
    return (
      <div className="flex w-full items-stretch rounded-md bg-slate-50 py-2">
        {signers.map((signer, index) => (
          <Fragment key={signer.name}>
            {index > 0 && (
              <Divider className="mx-0 my-1 flex-none" layout="vertical" />
            )}
            {/* equal halves: the box stays its own size and is centered in its half;
                the jabatan under the name (the last span of its block) stays on one line, and the
                name (the last block of the box) may use more than the width of the box itself: a
                name of three words fits on one line, a longer one takes two */}
            <div className="flex min-w-0 flex-1 justify-center [&>div>div:last-child]:!w-[9rem] [&_span:last-child]:whitespace-nowrap">
              {renderBox(signer)}
            </div>
          </Fragment>
        ))}
      </div>
    );
  }

  return (
    <div className="row-around-start w-full flex-wrap gap-0 rounded-md bg-slate-50 px-3 py-2">
      {signers.map((signer, index) => (
        <div key={signer.name} className="row-start-start">
          {index > 0 && <Divider className="h-[10rem] mx-3" layout="vertical" />}
          {renderBox(signer)}
        </div>
      ))}
    </div>
  );
};

export default SignatureRow;
